
import { Vue, Component, Prop,Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { FilterHelper } from "@newview/tools";
import {DicBusinesstypeoptionApi} from "@newview/system-api"
@Component({
  name: "dicSelect",
  components: {
  },
})
export default class dicSelect extends BaseVue {
  @Model('on-change') defaultValue!: any

  @Prop({ default: () => "" }) typeCode!: String; //字典类型编码
  @Prop({ default: () => true }) firstIsSelected!: Boolean; //默认选中第一项
  @Prop({ default: () => false }) isAll!: Boolean; //是否有全部选项
  // @Prop({ default: () => "" }) value!: any; //下拉列表值
  @Prop({ default: () => false }) disabled!: Boolean; //是否禁用
  @Prop({ default: () => "" }) name!: String; //下拉列表name
  @Prop({ default: () => true }) transfer!: Boolean; //下拉列表transfer   置于body内
  @Prop({ default: () => false }) clearable!: Boolean; //下拉列表clearable 清除
  @Prop({ default: () => "请选择" }) placeholder!: String; //下拉列表placeholder
  @Prop({ default: () => true }) filterable!: Boolean; //下拉列表filterable 搜索
  @Prop({ default: () => false }) onlyView!: Boolean; //是否只显示文本不编辑，默认为编辑状态
  @Watch("defaultValue")
  defaultValueChange(){
    // console.log(this.defaultValue)   
  }
  selOptions:any=[]
  dicBusinesstypeoptionApi:DicBusinesstypeoptionApi = new DicBusinesstypeoptionApi()
  async mounted() {
    let param:any ={
      typeCode : this.typeCode
    }
    let data:any = await this.dicBusinesstypeoptionApi.getDicOptions(param)
    if(data.code == 200&& data.data.length>0){
      for (const iterator of data.data) {
        this.selOptions.push({value:iterator.id,text:iterator.optionValue})
      }
    }


  }
  onSelect(value){
    this.$emit("on-select",value)
  }
  onChange(value){
    this.$emit("on-change",value)
  } 
  getSelectText(value){
    return FilterHelper.sysDicFilter(value,this.selOptions)
  }
}
